import React, { useEffect, useState } from "react";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import { Link } from "react-router-dom";
import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import BaseURL from "../../assets/utils/baseUrl";

const Agenda = () => {
  useDocumentTitle("Agenda - BAPENDA BEKASI");

  const [agenda, setAgenda] = useState([]);
  const [pageShow, setPageShow] = useState(0);

  const itemPerPage = 10;

  /* ── FETCH DATA ── */
  useEffect(() => {
    const getData = async () => {
      try {
        const res = await fetch(
          BaseURL + "index.php/api/Agenda?key=bapenda123"
        );
        const data = await res.json();

        // pastikan array
        setAgenda(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.log("Error fetch agenda:", err);
        setAgenda([]);
      }
    };

    getData();

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  /* ── PAGINATION LOGIC ── */
  const indexOfLastItem = (pageShow + 1) * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;

  const currentItems = agenda.slice(indexOfFirstItem, indexOfLastItem);
  const totalPage = Math.ceil(agenda.length / itemPerPage);

  /* ───────────────────────────────────────────── */

  return (
    <div className="page">
      <Header active="publikasi" />

      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Publikasi / Agenda" />

          <div className="page-title-wrapper">
            <div className="page-title">Agenda</div>
          </div>

          {/* ── LIST DATA ── */}
          <div className="informasi-list-wrapper">
            {currentItems.length > 0 ? (
              currentItems.map((item) => (
                <div
                  className="informasi-list-item"
                  key={item.id_agenda}
                >
                  <div className="informasi-list-thumbnail-wrapper">
                    <img
                      className="informasi-list-thumbnail"
                      src={
                        item.thumbnail
                          ? BaseURL +
                            "assets/images/agenda/" +
                            item.thumbnail
                          : "/no-image.png"
                      }
                      alt={item.judul}
                    />
                  </div>

                  <div className="informasi-list-informasi">
                    <div>
                      <p className="informasi-list-title">
                        {item.judul}
                      </p>

                      <p className="informasi-list-date">
                        {item.created_date}
                      </p>

                      <p className="informasi-list-desc">
                        {item.konten
                          ?.substring(0, 400)
                          ?.replace("(_newline)", " ") || "-"}{" "}
                        [ ... ]
                      </p>
                    </div>

                    <Link
                      to={"/agenda-detail/" + item.id_agenda}
                    >
                      <div className="informasi-list-desc link">
                        Selengkapnya
                      </div>
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: 20, textAlign: "center" }}>
                Tidak ada data agenda
              </div>
            )}
          </div>

          {/* ── PAGINATION ── */}
          <div className="pagination-wrapper">
            {Array.from({ length: totalPage }, (_, i) => (
              <div
                key={i}
                className={
                  i === pageShow
                    ? "page-number page-number-active"
                    : "page-number"
                }
                onClick={() => setPageShow(i)}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </section>

        <Sidebar />
      </main>

      <Footer />
    </div>
  );
};

export default Agenda;